<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oVJzrj/images/9780738219332.jpg?1734367810081" alt="This image is the cover for the book Organized Enough"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Organized Enough
      </h1>
      <p class="bookDescription body article font2">
        <b>Get organized—not obsessed! “Valuable, accessible wisdom that readers can employ immediately.” ―<i>Library Journal</i></b><br/><br/>If you’re looking to clean up but not clean out, if you want to declutter but don't want to throw out eighty percent of your stuff, if you want to be able to find matching socks in the morning but don’t want a color-coded sock drawer, you’ve come to the right place. <br/><br/><i>Organized Enough</i> offers a groundbreaking, science-driven method for getting—and staying—organized. Amanda Sullivan’s proven approach will teach you the lifelong habits of the organized, showing you how to make cleaning up effortless and automatic. With seven concepts to help you define your goals and seven essential and easygoing habits to keep chaos and clutter at bay, <i>Organized Enough</i> will teach you to reframe how you think about your space, your stuff, and your life. You’ll learn how to:Sort the “stuff” from the sentimentalBecome a paper-filing ninjaCultivate consistency, not chaosSet up systems that can run on autopilotLet go of guilt and start enjoying your home. . . and more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Sullivan
      </h2>
      
      <p class="authorDescription body article"><B>Amanda Sullivan</B> is a professional organizer, founder of The Perfect Daughter, and a media expert on organization. She has helped hundreds of clients, from hoarders to celebrities such as Lori Singer, Kimberly Guilfoyle, and Liz Murray to control home chaos. Amanda has appeared on <I>Good Morning America</I> and <I>Living it Up with Ali and Jack</I>. Her advice has appeared in national print magazines such as <I>Woman's Day</I> and <I>Fit Pregnancy</I>, as well as on popular websites such as Next Avenue and About.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Perseus Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ecd1b9c